import { Package } from "lucide-react";
import { useState } from "react";

const SIZES = {
  sm: "size-8 rounded-lg",
  md: "size-10 rounded-xl",
  lg: "size-20 rounded-2xl",
  hero: "aspect-[5/3] w-full rounded-2xl",
};

/** A square image with a quiet package glyph when there is no URL or it does not load. */
export function ImageTile({
  src,
  alt = "",
  size = "md",
}: {
  src?: string | null;
  /** Leave empty where the name sits next to the tile. */
  alt?: string;
  size?: keyof typeof SIZES;
}) {
  const [failed, setFailed] = useState<string | null>(null);
  const broken = !src || failed === src;

  return (
    <span
      className={`bg-surface-secondary text-muted relative flex shrink-0 items-center justify-center overflow-hidden ${SIZES[size]}`}
    >
      {broken ? (
        <Package aria-hidden="true" className="size-1/3" />
      ) : (
        <img
          alt={alt}
          className={
            size === "hero"
              ? "size-full object-contain p-4"
              : "size-full object-cover"
          }
          src={src}
          onError={() => setFailed(src)}
        />
      )}
    </span>
  );
}
